import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

export const formSchema = Yup.object().shape({
    selectedMedications: Yup.array().min(1, 'Wybierz przynajmniej jedną opcję').required(),
    isPregnat: Yup.string().required('Pole wymagane').nullable(),
    additionalDiseases: Yup.string().nullable().required('Pole wymagane'),
    additionalDiseasesDescription: Yup.string()
        .nullable()
        .when('additionalDiseases', (val, schema) => {
            if (val === 'yes') {
                return schema.required('Pole wymagane');
            }
            return schema;
        }),
    hasCare: Yup.string()
        .oneOf(['yes', 'no', null])
        .nullable()
        .when('additionalDiseases', (val, schema) => {
            if (val === 'yes') {
                return schema.required('Pole wymagane');
            }
            return schema;
        }),
    carePerson: Yup.string()
        .nullable()
        .when('hasCare', (val, schema) => {
            if (val === 'yes') {
                return schema.required('Pole wymagane');
            }
            return schema;
        }),
    operationsDescription: Yup.string()
        .nullable()
        .when('hasOperations', (val, schema) => {
            if (val === 'yes') {
                return schema.required('Pole wymagane');
            }
            return schema;
        }),
    operationsYears: Yup.string()
        .nullable()
        .when('hasOperations', (val, schema) => {
            if (val === 'yes') {
                return schema.required('Pole wymagane');
            }
            return schema;
        }),
    hasOperationComplications: Yup.string()
        .nullable()
        .oneOf(['yes', 'no', null])
        .when('hasOperations', (val, schema) => {
            if (val === 'yes') {
                return schema.required('Pole wymagane');
            }
            return schema;
        }),
    drugWasUsed: Yup.string().oneOf(['yes', 'no', null]).nullable().required('Pole wymagane'),
    hasDrugAllergies: Yup.string()
        .nullable()
        .when('drugWasUsed', (val, schema) => {
            if (val === 'yes') {
                return schema.required('Pole wymagane');
            }
            return schema;
        }),
    whatDrugsHasAllergies: Yup.string()
        .nullable()
        .when('hasDrugAllergies', (val, schema) => {
            if (val === 'yes') {
                return schema.required('Pole wymagane');
            }
            return schema;
        }),
    importantInformation: Yup.string().required('Pole wymagane'),
    hasOperations: Yup.string().nullable().oneOf(['yes', 'no', null]).required('Pole wymagane'),
    ...sharedSchema,
});
